export const tooltipFnMap = new WeakMap<HTMLElement, () => string>();

function updateTooltip(el: HTMLElement, value: unknown) {
    if (typeof value === 'function') {
        tooltipFnMap.set(el, value as () => string);
        el.setAttribute('data-tooltip', '');
    } else if (typeof value === 'string' && value) {
        tooltipFnMap.set(el, () => value);
        el.setAttribute('data-tooltip', '');
    } else {
        tooltipFnMap.delete(el);
        el.removeAttribute('data-tooltip');
    }
}

const XTooltipDirective = {
    mounted(el: HTMLElement, binding: DirectiveBinding) {
        updateTooltip(el, binding.value);
    },
    updated(el: HTMLElement, binding: DirectiveBinding) {
        updateTooltip(el, binding.value);
    },
    unmounted(el: HTMLElement) {
        tooltipFnMap.delete(el);
        el.removeAttribute('data-tooltip');
    },
};

export default XTooltipDirective;
